import React, { useState, useEffect } from 'react';
//imports core
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import useAuth from "hooks/useAuth";
import api from "assets/services/api.js";
import ModalDeleteOrder from "components/ModalDeleteOrder/ModalDeleteOrder";
import ModalUpdateOrder from 'components/ModalUpdateOrder/ModalUpdateOrder';
import ModalAddProductOrder from 'components/ModalAddProductOrder/ModalAddProductOrder';
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import { formatDate, formatDateWithHours } from "services/formatDate.js";
//imports material
import Tooltip from "@material-ui/core/Tooltip";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Button from '@mui/material/Button';
import { makeStyles } from "@material-ui/core/styles";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "200",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "0px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "60%",
            fontWeight: "300",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },
    floatRight: {
        float: "right"
    },
    marginlt: {
        marginTop: '0px',
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    },
    acctAll: {
        float: "right",
        marginTop: "-29px"
    },
    floatRight: {
        float: "right",
        marginRight: "56px"
    },
    bigcheckbox: {
        width: "30px",
        height: "30px"
    },
    cardCenter: {
        width: '100%',
        justifyContent: 'center',
        display: 'flex'
    }

};


const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

function TableOrderSellsman({ order, style, loadOrders, toogle }) {
    const classes = useStyles();
    const classes2 = useStyles2();
    const { storageId, user, garlicType } = useAuth();

    const [modalShowUpdate, setModalShowUpdate] = useState(false);
    const [modalShowDelete, setModalShowDelete] = useState(false);
    const [modalShowAddProduct, setModalShowAddProduct] = useState(false);
    const [index, setIndex] = useState(order[0] ? order[0] : { id: 1 });
    const [importModal, setImportModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const loadModal = async () => {
        setImportModal(true);
    }

    function callModalUpdate(index) {
        if (!modalShowUpdate) {
            loadModal();
        }
        setIndex(index);
        setModalShowUpdate(true);
    }

    function callModalDelete(index) {
        if (!modalShowDelete) {
            loadModal();
        }
        setIndex(index);
        setModalShowDelete(true)
    }

    function callModalAddProduct(index) {
        if (!modalShowAddProduct) {
            loadModal();
        }
        setIndex(index);
        setModalShowAddProduct(true)
    };

    async function generateOrderStatement(order_controller, client) {
        setLoading(true);
        const response = await api.post('/sell/generate/statement/pdf', {
            id: storageId,
            data: [{ "order_controller": order_controller }],
            type: "order",
            userType: "sellsman"
        }, {
            responseType: "blob", // Definido aqui
        }).then(async function (response) {
            let blob = new Blob([response.data], {
                responseType: "arraybuffer",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/pdf",
                },
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `Pedido_${client} - ${order_controller}.pdf`;
            link.click();
        }).catch(function (error) {
            console.log(error);
        });
        setLoading(false);
    };

    function getNf() {
        let teste = [];
        for (let i = 0; i < order.products.length; i++) {
            teste[i] = [];
            const parse_natures = {
                sell: 'Venda',
                bonification: 'Bonificação',
                sample: 'Amostra'
            };
            teste[i].push(order.products[i].name);
            teste[i].push(order.products[i].amount);
            teste[i].push(order.products[i].box);
            teste[i].push(order.payment);
            teste[i].push(parse_natures[order.nature]);
            teste[i].push("R$" + order.products[i].price);
            teste[i].push("R$" + order.products[i].discount);
            teste[i].push(order.products[i].batch);
            teste[i].push(formatDateWithHours(order.create));
            teste[i].push(formatDate(order.date));
            teste[i].push(order.observation);
            if (!toogle) {
                teste[i].push(
                    <div className={classes2.tableActions}>
                        <Tooltip id="tooltip-top-start" title="Deletar" placement="top" classes={{ tooltip: classes2.tooltip }} >
                            <IconButton aria-label="Close" className={classes2.tableActionButton} onClick={() => callModalDelete(order.products[i])} >
                                <Close className={classes2.tableActionButtonIcon + " " + classes2.close} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip id="tooltip-top" title="Editar" placement="top" classes={{ tooltip: classes2.tooltip }} >
                            <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callModalUpdate(order.products[i])} >
                                <Edit className={classes2.tableActionButtonIcon + " " + classes2.edit} />
                            </IconButton>
                        </Tooltip>
                    </div>
                );
            };
        }
        return teste;
    }

    return (
        <GridItem style={style} xs={12} sm={12} md={12} >
            <div className={classes.marginlt}>
                <GridItem xs={12} sm={12} md={12}>
                    <Card className={classes.test}>
                        <CardHeader className={classes.zindex} color={(order.cancelled ? "warning" : (order.invoice ? "success" : "danger"))}>
                            <h4 className={classes.cardTitleWhite}>
                                {order.client.social_reason} - <Button variant="outlined"
                                    onClick={() => { generateOrderStatement(order.order_controller, order.client.social_reason) }}
                                    style={{
                                        borderColor: 'white',
                                        borderWidth: '3px',
                                        color: 'white',
                                        fontSize: '17px'
                                    }}>
                                    {order.order_controller}
                                </Button>
                            </h4>
                            <h5 className={classes.cardTitleWhite}> {order.client.address}</h5>
                            <h6 className={classes.cardTitleWhite}>Valor total: R$ {parseFloat(order.total).toFixed(2)}</h6>
                        </CardHeader>
                        <CardBody className={classes.ftsize}>
                            <Table tableHeaderColor="danger"
                                tableHead={["Produto", "Quantidade", "Quantidade em Caixas", "Pagamento", "Natureza da operação", "Valor unitário", "Desconto", "Lote", "Data do pedido", "Data de entrega", "Observação", "Ações"]}
                                tableData={getNf()}>
                            </Table>
                            <div className={classes.cardCenter}>
                                <Tooltip
                                    id="tooltip-top"
                                    title="Adicionar produto"
                                    placement="top"
                                    classes={{ tooltip: classes2.tooltip }}
                                >
                                    <IconButton
                                        aria-label="Edit"
                                        className={classes2.buttonIcon}
                                        onClick={() => callModalAddProduct(order)}

                                    >
                                        <AddCircleOutlineIcon
                                            sx={{ fontSize: 40 }}
                                            className={
                                                classes2.sizeAddContact + " " + classes2.addContacts
                                            }
                                        />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </CardBody>
                    </Card>
                </GridItem >
            </div>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={loading}
                onClick={() => { }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            {importModal && modalShowDelete && (
                <ModalDeleteOrder key={String("del_" + index.id)} props={index} loadOrders={loadOrders} show={modalShowDelete}
                    onHide={() => setModalShowDelete(false)} />
            )}
            {importModal && modalShowUpdate && (
                <ModalUpdateOrder key={String("upd_" + index.id)} props={index} loadOrders={loadOrders} show={modalShowUpdate}
                    onHide={() => setModalShowUpdate(false)} />
            )}
            {importModal && modalShowAddProduct && (
                <ModalAddProductOrder key={String("upd_" + index.id)} props={index} loadOrders={loadOrders} show={modalShowAddProduct}
                    onHide={() => setModalShowAddProduct(false)} />
            )}
        </GridItem>
    );
}

export default TableOrderSellsman;